export default {
  'APP': {
    'logoLink':'https://www.hkma.gov.hk/eng/',
    'tiptitle':[
      'Font Size 100%',
      'Font Size 150%',
      'Font Size 200%',
      'listen captcha code',
      'refresh captcha code',
      'close button',
      'verification code',
    ],
    'reminder':[
      'Reminder'
    ],
    'title': 'Hong Kong Monetary Authority - Complaint Form in relation to Banking Products and Services',
    'pTitle': [
      'Part 1. Who is making the complaint?',
      'Part 2. Who are you complaining about?',
      'Part 3. What is your complaint about?',
      'Part 4. What is the account/transaction involved?',
      'Part 4. Supporting documents relevant to your complaint (e.g. business card of the staff, bank’s reply, bank statements, product brochures, etc.)',
      'Notes for Complainant',
      'Consent to Disclose Your Information and Personal Data',
      'wrongPage'
    ],
    'mode': ['Normal Mode', 'Color Blindness Mode'],
    'complainttitle':['Complaint Form in relation to Banking Products and Services'],
    'content':{
      // complaint模块里的三段内容
      'complaint':{
        'first':['Please complete this online complaint form if you wish to lodge a complaint with the Hong Kong Monetary Authority (HKMA) against a licensed bank, restricted licence bank or deposit-taking company (collectively referred to as ',
          'banks',
          ').'
        ],
        'second':['Before you lodge a complaint, please read the ',
          '"FAQs – Complaints about Banking Products or Services"',
          ' and ',
          '"Flowchart of the Complaints Handling Process"',
          ', which explain our role and procedures in handling complaints.'
        ],
        'third':[
          'Alternatively, you are encouraged to make a formal complaint to the bank first in order to give it a chance to resolve your complaint at an early stage.  Please refer to the ',
          '"List of banks\' contact persons for handling customer complaints" ',
          'for the contact details of these officers.'
        ],
        'forth':[
          'You have to give the HKMA the necessary consent to handle your complaint on your behalf because we may need to disclose the information you have given to us (including your personal data) to the bank and other third parties for purposes related to the handling of your complaint when necessary.'
        ],
        // complaint里的链接
        'link':[
          'https://vpr.hkma.gov.hk/eng/regulatory-resources/registers/register-of-ais-and-lros/',
          'https://www.hkma.gov.hk/eng/smart-consumers/frequently-asked-questions/banking/b/',
          'https://www.hkma.gov.hk/media/eng/doc/other-information/flowchart_on_complaints_en.pdf',
          'https://www.hkma.gov.hk/media/eng/doc/other-information/Banks_contact_persons.pdf',
        ],
        // 按钮文本
        'btn':[
          'Enter'
        ]
      },
      // home模块里的内容
      'home':{
        'left':'(',
        'right':')',
        'msg':[
          {
            'title':'(1)I would like the HKMA to consider and handle my complaint.'
          },
          {
            'title':'(2)I understand and agree that all information and personal data supplied by me will be used for purposes related to the handling and/or investigation of my complaint and the discharge of the HKMA’s statutory functions.'
          },
          {
            'title':'(3)I understand and agree that the HKMA may disclose or transfer the information and personal data supplied by me to third parties (i) for purposes related to the handling and/or investigation of my complaint, including the bank and/or its staff who are the subject of the complaint and other relevant regulators, authorities and law enforcement agencies; and (ii) where permitted or required by law.'
          },
          {
            'title':'(4)I understand that should I wish to request access to or correction of my personal data held by the HKMA, I may do so in writing to the Data Protection Officer of the Enforcement and AML Department of the HKMA (55th Floor, Two International Finance Centre, 8 Finance Street, Central, Hong Kong). The HKMA may charge a reasonable fee for complying with a data access request.'
          },
          {
            'title':'(5)I understand that I am not obliged to supply the HKMA with information and personal data and agree to do so on a voluntary basis. If the information or personal data provided by me are not accurate or complete, the processing of my complaint may be affected.'
          }
        ],
        'msg1':[
          {
            'title':'I would like the HKMA to consider and handle my complaint.'
          },
          {
            'title':'I understand and agree that all information and personal data supplied by me will be used for purposes related to the handling and/or investigation of my complaint and the discharge of the HKMA’s statutory functions.'
          },
          {
            'title':'I understand and agree that the HKMA may disclose or transfer the information and personal data supplied by me to third parties (i) for purposes related to the handling and/or investigation of my complaint, including the bank and/or its staff who are the subject of the complaint and other relevant regulators, authorities and law enforcement agencies; and (ii) where permitted or required by law.'
          },
          {
            'title':'I understand that should I wish to request access to or correction of my personal data held by the HKMA, I may do so in writing to the Data Protection Officer of the Enforcement and AML Department of the HKMA (55th Floor, Two International Finance Centre, 8 Finance Street, Central, Hong Kong). The HKMA may charge a reasonable fee for complying with a data access request.'
          },
          {
            'title':'I understand that I am not obliged to supply the HKMA with information and personal data and agree to do so on a voluntary basis. If the information or personal data provided by me are not accurate or complete, the processing of my complaint may be affected.'
          }
        ],
        // 按钮文本
        'btn':['Agree','Disagree'],
        // 点击NOT AGREE弹出提示
        'tips':[
          'If you have any concern on our handling of personal data, please contact us by email (',
          'bankcomplaints@hkma.gov.hk',
          ').'
        ]
      },
      // note模块里的内容
      'note':{
        'msg1':[
          {
            'title': 'This form consists of 4 sections. Please click "Next" or "Previous" to the next or previous section.'
          },
          {
            'title': 'If you want to temporarily save the information and resume later, please click "Save" at the bottom of each section. This function allows you to save your information to a temporary file in your PC. The file will be encrypted and password protected but the attachment will not be saved. The temporary file will become invalid after 7 days.'
          },
          {
            'title': 'To resume, please click "Upload previous input" at the bottom of this page, upload the temporarily saved file from your PC and input the password provided.'
          },
          {
            'title': 'The last section of this form allows you to upload supporting documents with a maximum size of 10MB per file and a maximum number of 10 files. Should you wish to provide additional documents, please send them to us by email or by post.  Please quote the online submission reference number, which will be provided to you after the form is submitted, in your correspondence with the HKMA.'
          }
        ],
        'msg2':[
          {'title':'Please use the following settings in your computer:'},
          {'title':'Browser: Google Chrome/Internet Explorer 9 or above/Safari 5'},
          {'title':'Resolution: 1024 x 768'},
          {'title':'Privacy level: Medium'},
          {'title':'If you still have a problem in loading the complaint form, please change the security level to Low or accept all cookies.'},
        ],
        'msg21':[
          {'title':'5. Please use the following settings in your computer:'},
          {'title':' - Browser: Google Chrome/Internet Explorer 9 or above/Safari 5'},
          {'title':' - Resolution: 1024 x 768'},
          {'title':' - Privacy level: Medium'},
          {'title':' - If you still have a problem in loading the complaint form, please change the security level to Low or accept all cookies.'},
        ],
        'msg3':[
          {'title':'For safety, please do not use a public computer.'},
          {'title':'For assistance, please call 2878'},
          {'title':'1378 during office hours. All telephone conversations between you and the HKMA may be recorded, irrespective of whether you dial in or we call you back so as to ensure our service quality.'}
        ],
        // 按钮的文本
        'btn':['Lodge a new complaint','Upload previous input'],
        // Lodge a new complaint按钮的文本
        'lodge':[
          'Please enter the following captcha.',
          'Enter captcha',
          'OK',
          'Verification code failed, please enter the verification code in the picture above.'
        ],
        // Upload previous input按钮的文本
        'resume':{
          'header':['Step 1. Please select the temporary file.','Upload file'],
          'main':[
            'Step 2. Please enter the password.',
            'Step 3. Please enter the following captcha.',
            'OK',
            'Please fill in the six digits password provided to you before.',
            'Please select the file you downloaded before.',
            'Only file in HKMA format (*.hkma) is supported.',
            'Wrong verification code or password.',
            'Please enter a file name starting with HKMAbankcomplaint.',
            'Failed to parse the file, valid for only 7 days.',
            'The temporary file/ password/ captcha you proivded is invalid. Please try again.',
            'Resume the complaint sheet, the incoming file is empty.',
            'Incorrect password.',
            'The file is no longer valid.',
          ]
        }
      },
      //必填项改成这种提示625
      'mandatory':'This is a mandatory field',
      // 公共部分
      'part':{
        'dialogTip':'The information will be saved in your computer as a temporary file.',
        // 按钮组
        'btngroup':['Previous','Save','Next','Preview','Submit','Exit'],
        // 保存按钮的文本
        'savebtn':['Your information will be saved in your computer. You can retrieve the temporarily saved file within 7 days. Attachments will not be saved so you will need to attach them again when you resume.'],
        // 保存文件时弹出的弹框的文本
        'popout':['Please save the following password for retrieving and opening the temporarily saved file.', 'Note: This complaint form has not been submitted.  Please fill in all the sections of this complaint form for a complete submission within 7 days.' ],
        //下拉框
        'select':'Select...',
        //For Exit Prompt
        'exitPrompt' : [
          'Do you want to quit this page?',
          'OK',
          'Cancel'
        ],
        //For Skip Ahead
        'skipAhead' : [
          'Please complete previous part(s) first.',
        ],
        //For Menu Aria-Label and Alt Text
        'menu' : [
          'Part',
          'Completed',
          'Incomplete',
          'In Progress',
        ],
        // 提示
        'tips':[
          'This is a mandatory field',
          'Not empty & 4 digits (alphanumeric)',
          'Please enter the correct email format',
          'Please input surname',
          'Please input the phone number',
          'Please select the address type',
          'It does not match with the above email address.  Please re-enter again.',
        ],
        // 性别,点击选择框后的内容
        'genderList': [{
          'label': 'Select...',
          'value': ''
         },{
          'label': 'Mr',
          'value': 'MR'
         },{
          'label': 'Mrs',
          'value': 'MRS'
         },{
          'label': 'Ms',
          'value': 'MS'
         },{
          'label': 'N/A',
          'value': 'NA'
         },],
        'addressList':[{
          'label':'By post - Correspondence Address',
          'value':'1'
        },{
          'label':'By eMail - eMail Address',
          'value':'2'
        }]
      },
      // part1模块里的内容
      'part1':{
        'title':['1. Who is making the complaint?'],
        // 表单内容
        'form':{
          'content':[
            'Is the complaint being lodged by an individual or a corporate customer?',
            'Individual',
            'Corporate'
          ],
          // 页面中相同的文本
          'common':{
            'method':[
              'By post',
              'By email',
              'Either one or both',
              'Please input correspondence address',
              'Please provide correspondence address and/or email address for your chosen method of communication.',
              'Please provide correspondence address and/or email address for your chosen method of communication.',
            ],
            'text':[
              'Surname',
              'Given Name',
              'Identity document number (first 4 digits)',
              'Correspondence address',
              'Email address',
              'Telephone number',
              'Do you wish to appoint a representative to submit information and to enquire about the progress of your complaint?',
              'Yes',
              'No',
              'This is a mandatory field',
              'Correspondence address and/or email address should be entered.',
              'Please complete the mandatory field(s).',
              'Please input surname',
              'Please select the appellation',
              'Please select the type of identity document',
              'Please input first name',
              'Preferred method of written communication with the HKMA',
              '(In general, the HKMA’s correspondence will be sent to complainant directly.)',
              'Please re-enter email address',
            ],
            // 证件类型,点击选择框后的内容
            'identityList': [{
              'label': 'Select...',
              'value': ''
             },{
              'label': 'HKID',
              'value': 'HKID'
             },{
              'label': 'Passport',
              'value': 'PASSPORT'
             },{
              'label': 'Travel document',
              'value': 'TRAVEL'
            }],
            // 地址是否相同
            'sameAddress': 'Same as complainant'
          },
          // 点击Individual按钮后的内容
          'individual':['Name of complainant'],
          // 点击Corporate按钮后的内容
          'corporate':{
            'text':[
              'Company name',
              'Company’s authorised representative',
              '(i.e. Director/Authorised signatory)',
              'When was the company established?',
              'Was the company incorporated in Hong Kong?',
              'What business does it conduct?',
              'Please input the company name',
              'Please input the establishment time of the company',
              "Please input the company's business",
              "Example Year Format: YYYY",
              "Please enter the correct year format: YYYY",
            ]
          },
          // 委派代表的信息
          'delegate':['Name of representative','Add Representative'],
          // 符号的解释
          'explain':['Mandatory','Either one or both'],
          // 填写代表的个数限制的弹框文本
          'representativenum':['Cannot add more than 2 representative.'],
          "complaintAgain":'Have you previously lodged a complaint with the HKMA, which is related to the current one?',
          "complaintNum":'Reference number of your complaint (If any)',
          "fieldError" : [
            "Please complete the mandatory field(s).",
            "Please complete the mandatory field(s).",
            "Please Check 'Transaction date' field",
            "Please Check 'Disputed amount' field",
          ]
        }
      },
      // part2模块里的内容
      'part2':{
        'title':['2. Who are you complaining about?'],
        'form':{
          'bankname':['Name of the bank'],
          // 銀行文案
          'bankText': {
            'name':'Name of the bank',
            'same':'Same as above',
            'branch':'Branch / Department',
            'staff':'Name of the staff',
            'sure':'Surname',
            'first':'Given Name',
            'job':'Job title',
            'hkma':'HKMA registration number (if applicable)',
            'have':'Have you lodged a complaint with the bank?',
            'y':'Yes',
            'n':'No',
            'number':'Bank’s complaint reference number',
            'date':'Date(s) of complaint to the bank:',
            'ifStaff':'Is there any bank staff involved in the complaint?',
            'ifAccount':'Is there any account/transaction involved in the complaint?',
          },
          'explain':['Mandatory'],
          'clickbox':['Add Bank','Add Bank Staff'],
          // 弹框内容
          'popout':'Cannot add more than 3 banks',
          'tips':[
            'Please enter the correct date format(DD/MM/YYYY, DD/MM/YYYY,...)',
            'Please input the Branch or Department',
            'Please input the job title',
            'Please input the HKMA registration number',
            'The same date exists in the date entered',
            'Example Date Format: DD/MM/YYYY, DD/MM/YYYY,...',
            'Please input Name of the bank',
            'Please input Is there any bank staff involved in the complaint?',
            'Please input Is there any account/transaction involved in the complaint?',
            'Please input Have you lodged a complaint with the bank?',
          ],
          'lodgedWithBank' : [
            'You are encouraged to make a formal complaint to the bank first in order to give it a chance to resolve your complaint at an early stage.  Please refer to the ',
            '"List of banks\' contact persons for handling customer complaints"',
            'for the contact details of these officers.',
          ],
          'dropdownLabel' : [
            'Disputed Type',
            'Currency',
          ]
        }
      },
      // part3模块里的内容
      'part3':[
        '3. What is your complaint about?',
        'Please describe precisely in point form all the matters you are not satisfied with: ',
        'Add bullet point',
        'Please describe the incident(s) giving rise to your complaint, preferably in chronological order. ',
        'Cannot add more than 10 rows.',
        'Please provide what you are not satisfied with and/or the incident(s) giving rise to your complaint.'
      ],
      // part4模块里的内容
      'part4':{
        'title':['4. What is the account/transaction involved?'],
        'subtitle':['Please provide details of the account or transaction involved in your complaint:'],
        // 账户类型
        'accounttype':[
          'Account type',
          'Sole account',
          'Joint account',
          'Company account',
        ],
        // 点击sole account和joint account按钮显示的内容
        'account':[
          'Account number',
          'Name of account holder',
          'Surname',
          'Given Name',
          'Product name',
          'Transaction date',
          'Disputed amount',
          'Transaction date',
          'Transaction month',
          'Transaction year',
        ],
        // 爭議類型
        'disputedtype': [
          {
            'label': 'Please Select',
            'value': ''
          },
          {
            'label': 'Transaction amount',
            'value': 'TRANSACTION'
          },
          {
            'label': 'Loss',
            'value': 'LOSS'
          },
          {
            'label': 'Interest',
            'value': 'INTEREST'
          },
          {
            'label': 'Fee',
            'value': 'FEE'
          },
        ],
        // 幣種
        'currencytype':[
          {
            'label': 'Please Select',
            'value': ''
          },
          {
            'label':'HKD',
            'value':'HKD'
          },
          {
            'label':'USD',
            'value':'USD'
          },
          {
            'label':'RMB',
            'value':'RMB'
          },
          {
            'label':'GBP',
            'value':'GBP'
          },
          {
            'label':'JPY',
            'value':'JPY'
          },
          {
            'label':'EUR',
            'value':'EUR'
          },
          {
            'label':'CHF',
            'value':'CHF'
          },
          {
            'label':'AUD',
            'value':'AUD'
          },
          {
            'label':'CAD',
            'value':'CAD'
          },
          {
            'label':'NZD',
            'value':'NZD'
          },
          {
            'label':'THB',
            'value':'THB'
          },
          {
            'label':'SGD',
            'value':'SGD'
          },
          {
            'label':'SEK',
            'value':'SEK'
          },
          {
            'label':'DKK',
            'value':'DKK'
          },
          {
            'label':'Others',
            'value':'Others'
          }
        ],
        // 添加框
        'addbox':['Add Account / Transaction','Add account holder','Add Account', 'Add Transaction'],
        // 争议金额
        'amountTip':'Maximum 15 digits and 4 decimals',
        // 日期提示
        'dateTip':'Invalid date format',
        // 弹框
        'popout':[
          'Cannot add more than 3 account holders.',
          'Cannot add more than 10 accounts / transactions.'
        ],
        'tips':[
          'Please input the account number',
          'Please input the product name',
          'Please input date with 2 digits,such as 01 10 ,etc',
          'Please input month with 2 digits,such as 01 10 ,etc',
          'Please input year with 4 digits,such as 2019,etc',
        ]
      },
      // part5模块里的内容
      'part5':{
        'title':['4. Supporting documents relevant to your complaint (e.g. business card of the staff, bank’s reply, bank statements, product brochures, etc.)'],
        'doc':['Add Document'],
        'del':'Remove',
        'upload':'uploading...',
        'memo':[
          'Each file size cannot exceed 10MB. A maximum of 10 files can be uploaded. Only "GIF, JPG, JPEG, PNG, TIFF, TIF, PDF" files are accepted. ',
          'For attachments exceeding the size limit or in other formats, please send them to us by email (',
          ') or by post (Complaint Processing Centre, Hong Kong Monetary Authority, 55th Floor, Two International Finance Centre, 8 Finance Street, Central, Hong Kong).'
        ],
        'attention':[
          'Attention',
          'File upload failure. Please send it to us by email or by post.'
        ],
        'prompt':[
          'Cannot add more than 10 documents.',
          'Only "GIF, JPG, JPEG, PNG, TIFF, TIF, PDF" files are accepted.',
          'You cannot add the same file'
        ]
      },
      //PREVIEW模块的内容
      'preview':[
        'Preview',
        'Edit',
        'By submitting this form, I acknowledge and confirm the followings:',
        'Complaint Processing Centre',
        'Telephone: 2878 1378',
        'Hong Kong Monetary Authority',
        'Fax: 2509 3990',
        '55th Floor, Two International Finance Centre, 8 Finance Street, Central, Hong Kong',
        'Email: ',
        ' All telephone conversations between you and the HKMA may be recorded, irrespective of whether you dial in or we call you back so as to ensure our service quality.',
        '',
        'Part',
        'Menu'
      ],
      //SUBMIT模块的内容
      'submit':[
        'Your complaint form has been submitted',
        'The online submission reference number is',
        'If you have any further information in relation to your complaint, please send it to us by email (',
        'Print',
        'Save a printed version',
        'Exit',
        ') or by post (Complaint Processing Centre, Hong Kong Monetary Authority, 55th Floor, Two International Finance Centre, 8 Finance Street, Central, Hong Kong). Please quote the above reference number in your correspondence.',
        'In progress...',
        'Are you sure to quit the page? The form cannot be printed or saved after you quit.',
        'Confirm',
        'Cancel',
        'Please save a printed version of the complaint form for record.',
      ],
      'submitDate':'Submission date',
      //wrongPage的内容
      'wrongPage':{
        'tips':[
          "Sorry, you can't enter this page directly.",
          'Please return to the ',
          'home page',
          '.',
        ]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/Language/English.js